import styled from 'styled-components'
import breakpoint from 'tools/styled-components-breakpoint'
import { pixelise } from 'tools/style'
import Flex from 'components/Flex'
import { gutterSize } from 'theme/default'

const getGutterSize = (fallback) => (props) => pixelise((props.gutterSize || fallback) / 2)

const Row = styled(Flex).attrs(() => ({
  flexWrap: 'wrap'
}))`
  ${breakpoint('mobile')`
    margin-right: -${getGutterSize(gutterSize.mobile)};
    margin-left: -${getGutterSize(gutterSize.mobile)};
  `}
  ${breakpoint('tablet')`
    margin-right: -${getGutterSize(gutterSize.tablet)};
    margin-left: -${getGutterSize(gutterSize.tablet)};
  `}
  ${breakpoint('desktop')`
    margin-right: -${getGutterSize(gutterSize.desktop)};
    margin-left: -${getGutterSize(gutterSize.desktop)};
  `}
`

export default Row
